module.exports = __webpack_public_path__ + "img/customer_service_QRcode.f1cdeade.jpg";